import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const ComponentsEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-components-edit-view" */ './ui/components'),
	),
	getPreloadProps: () => ({}),
});

export default ComponentsEditViewEntryPoint;
